"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _range2 = _interopRequireDefault(require("lodash/range"));

var _chunk = _interopRequireDefault(require("lodash/chunk"));

var _elevation = require("@amzn/meridian-tokens/base/elevation");

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _getCalendarMonth = _interopRequireDefault(require("./../_utils/get-calendar-month"));

var _dateString = require("./../_utils/date-string");

var _token = require("./../_utils/token");

var _text = _interopRequireDefault(require("./../_styles/text"));

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _dateLocales = require("./../_utils/date-locales");

var _intlDateTimeFormat = require("./../_utils/intl-date-time-format");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var daysInWeek = 7;
var dateFormat = {
  weekday: "long",
  day: "numeric",
  month: "short",
  year: "numeric"
}; // HACK: Grid column styles for IE11 because IE11 doesn't automatically assign
// row/column placement based on DOM placement - you have to manually set row
// and column numbers for each item.

var msWeekGridStyles = _objectSpread({
  display: "-ms-grid",
  msGridColumns: "(1fr)[".concat(daysInWeek, "]")
}, (0, _range2["default"])(daysInWeek).reduce(function (gridItemStyles, index) {
  gridItemStyles["& > *:nth-of-type(".concat(index + 1, ")")] = {
    display: "block",
    msGridColumn: index + 1
  };
  return gridItemStyles;
}, {}));

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var renderingCustomDate = _ref.renderingCustomDate,
      showFocusRing = _ref.showFocusRing;
  var dayBorderRadius = t("dayBorderRadius");
  return (0, _emotion.css)((0, _text["default"])(t), // HACK: CSS "grid" for IE11
  {
    tr: msWeekGridStyles
  }, {
    borderCollapse: "separate",
    borderSpacing: 0,
    tr: {
      display: "grid",
      gridTemplateColumns: "repeat(".concat(daysInWeek, ", 1fr)")
    },

    /**
     * Month header styles
     */
    "& > thead > tr:first-child > th": {
      display: "block",
      textAlign: "center",
      fontWeight: t("monthHeaderFontWeight"),
      fontSize: t("monthHeaderFontSize"),
      margin: 0,
      gridColumn: "1 / -1",
      // HACK: CSS "grid" for IE11
      msGridRow: 1,
      msGridColumn: 1,
      msGridColumnSpan: daysInWeek,
      padding: 0
    },

    /**
     * Day of week header styles
     */
    "& > thead > tr > th": {
      fontWeight: t("dayOfWeekHeaderFontWeight"),
      fontSize: t("dayOfWeekHeaderFontSize"),
      position: "relative",
      textAlign: "center",
      marginTop: t("spacingVertical") * 2,
      marginBottom: t("spacingVertical"),
      padding: 0
    },

    /**
     * Day styles
     */
    "& > tbody > tr > td:not([aria-hidden])": {
      position: "relative",
      textAlign: "center",
      cursor: "pointer",
      borderRadius: dayBorderRadius,
      color: t("dayForegroundColorDefault"),
      backgroundColor: t("dayBackgroundColorDefault"),
      zIndex: _elevation.elevationBackground,
      transition: t.transitionCss("dayMotion", ["color", "background-color", "border-radius"]),
      // If we're *not* rendering a custom day then fix the aspect ratio at
      // 0.85, otherwise leave the aspect ratio up to the custom day renderer.
      height: renderingCustomDate ? undefined : 34,
      "& > span": renderingCustomDate ? undefined : {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      // Selected
      "&[mdn-mini-cal-state=selected]": {
        color: t("dayForegroundColorSelected"),
        backgroundColor: t("dayBackgroundColorSelected")
      },
      // Highlighted
      "&[mdn-mini-cal-state=highlighted]": {
        color: t("dayForegroundColorHighlighted"),
        backgroundColor: t("dayBackgroundColorHighlighted")
      },
      // Disabled
      "&[mdn-mini-cal-state=disabled]": {
        color: t("dayForegroundColorDisabled"),
        backgroundColor: t("dayBackgroundColorDisabled"),
        cursor: "not-allowed",
        "& > span": {
          textDecoration: "line-through"
        }
      },
      // Hover/pressed
      "&:not([mdn-mini-cal-state=disabled])": {
        "&:hover": {
          color: t("dayForegroundColorHover"),
          backgroundColor: t("dayBackgroundColorHover")
        },
        "&:active": {
          color: t("dayForegroundColorPressed"),
          backgroundColor: t("dayBackgroundColorPressed")
        }
      },
      // Current day indicator
      "&[aria-current='date']:before": {
        content: "\"\"",
        position: "absolute",
        width: t("indicatorWidth"),
        height: t("indicatorHeight"),
        backgroundColor: t("indicatorColor"),
        borderRadius: t("indicatorBorderRadius"),
        left: "50%",
        bottom: t("indicatorSpacingVertical"),
        transform: "translateX(-50%)"
      },
      // When rendering custom days, add padding to the bottom
      // so the indicator does not clash with the content. Add
      // padding to top to get vertical centering.
      padding: renderingCustomDate ? "".concat(t("indicatorHeight") + t("indicatorSpacingVertical"), "px 0") : 0,
      // Focus ring
      "&:focus": showFocusRing ? _objectSpread({
        // Turn off default focus ring
        outline: "none",
        // This is used to ensure that the focus ring is shown above all adjacent
        // elements. Revisit this once we move from an outline-based focus ring to
        // a psuedo-element-based focus ring.
        zIndex: _elevation.elevationForeground
      }, (0, _focusRing["default"])(t.tokens, {
        focus: true,
        borderRadius: dayBorderRadius,
        gapColor: t.tokens.themeBackgroundPrimaryDefault,
        offset: 4
      })) : undefined,
      // Left cap
      "&:not([mdn-mini-cal-left-cap])": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      // Right cap
      "&:not([mdn-mini-cal-right-cap])": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  });
}, ["renderingCustomDate", "showFocusRing"]);

var shouldNotUpdate = function shouldNotUpdate(prevProps, nextProps) {
  return prevProps.hidden && nextProps.hidden;
};

var MiniCalendarPage = /*#__PURE__*/_react["default"].memo( /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var viewDate = props.viewDate,
      locale = props.locale,
      showFocusRing = props.showFocusRing,
      dateLabel = props.dateLabel;

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _getCalendarMonth["default"])({
      date: viewDate,
      locale: locale,
      monthLabelFormat: {
        month: "long",
        year: "numeric"
      },
      headerLabelFormat: {
        weekday: (0, _dateLocales.getDateLocale)(locale).compactDayOfWeekFormat
      }
    });
  }, [viewDate, locale]),
      days = _useMemo.days,
      dayOfWeekLabels = _useMemo.dayOfWeekLabels,
      monthLabel = _useMemo.monthLabel;

  var renderingCustomDate = props.renderDate !== undefined || props.renderDay !== undefined;
  var weeks = (0, _chunk["default"])(days, daysInWeek);
  return /*#__PURE__*/_react["default"].createElement("table", {
    ref: ref,
    className: (0, _emotion.cx)(styles(props.t, {
      renderingCustomDate: renderingCustomDate,
      showFocusRing: showFocusRing
    }), props.className),
    "aria-hidden": props.hidden,
    "mdn-mini-cal-page": ""
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("tr", {
    dateTime: "".concat((0, _dateString.getYear)(viewDate), "-").concat((0, _dateString.getMonth)(viewDate))
  }, /*#__PURE__*/_react["default"].createElement("th", null, monthLabel)), /*#__PURE__*/_react["default"].createElement("tr", null, dayOfWeekLabels.map(function (_ref2) {
    var label = _ref2.label,
        _long = _ref2["long"];
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: _long,
      title: _long
    }, label);
  }))), /*#__PURE__*/_react["default"].createElement("tbody", null, weeks.map(function (week, index) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      role: "row",
      key: index
    }, week.map(function (_ref3) {
      var dateObject = _ref3.dateObject,
          dateString = _ref3.dateString,
          label = _ref3.label,
          inMonth = _ref3.inMonth;

      // If the day falls within the given month, render
      if (inMonth) {
        var selected = props.selectedDates(dateString);
        var disabled = props.disabledDates(dateString);

        var _range = props.rangeDates(dateString);

        var current = dateString === props.now;
        var leftCap = !_range || !props.rangeDates((0, _dateString.toDateString)((0, _addDays["default"])(dateObject, -1)));
        var rightCap = !_range || !props.rangeDates((0, _dateString.toDateString)((0, _addDays["default"])(dateObject, 1)));
        var state = selected ? "selected" : disabled ? "disabled" : _range ? "highlighted" : undefined;
        var formattedDate = (0, _intlDateTimeFormat.intlDateTimeFormat)(dateObject, dateFormat, locale);
        var screenReaderLabel = dateLabel ? dateLabel({
          date: dateString,
          label: formattedDate,
          current: current,
          selected: selected,
          disabled: disabled,
          range: _range
        }) : formattedDate;
        return (
          /*#__PURE__*/
          // NOTE: mdn-text is used to tell any Text components dropped into the
          // calendar via the `renderDay` function to inherit the text styles of the
          // calendar by default.
          // NOTE: keyboard interaction is handled up at the calendar level
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          _react["default"].createElement("td", {
            key: dateString,
            "aria-current": current ? "date" : undefined,
            "mdn-mini-cal-state": state,
            "mdn-mini-cal-left-cap": leftCap ? "" : undefined,
            "mdn-mini-cal-right-cap": rightCap ? "" : undefined,
            "mdn-text": "",
            onClick: props.onClickDate && !disabled ? function () {
              return props.onClickDate(dateString);
            } : undefined,
            id: props.dateIds(dateString),
            onMouseEnter: props.onMouseEnterDate ? function () {
              return props.onMouseEnterDate(disabled ? undefined : dateString);
            } : undefined,
            onMouseLeave: props.onMouseEnterDate ? function () {
              return props.onMouseEnterDate(undefined);
            } : undefined,
            tabIndex: dateString === props.focusDate ? "0" : "-1" // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            ,
            role: "button",
            "aria-label": screenReaderLabel,
            "aria-disabled": disabled
          }, renderingCustomDate ? props.renderDate ? props.renderDate({
            label: "".concat(label),
            date: dateString,
            current: current,
            selected: selected,
            disabled: disabled,
            range: _range
          }) : props.renderDay({
            label: "".concat(label),
            date: dateString,
            current: current,
            selected: selected,
            disabled: disabled,
            range: _range
          }) : /*#__PURE__*/_react["default"].createElement("span", {
            "aria-hidden": "true"
          }, label))
        );
      } else {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: dateString,
          "aria-hidden": "true",
          tabIndex: "-1"
        });
      }
    }));
  })));
}), shouldNotUpdate);

MiniCalendarPage.propTypes = process.env.NODE_ENV !== "production" ? {
  dateIds: _propTypes["default"].func.isRequired,
  disabledDates: _propTypes["default"].func.isRequired,
  locale: _propTypes["default"].string.isRequired,
  now: _propTypes["default"].string.isRequired,
  rangeDates: _propTypes["default"].func.isRequired,
  selectedDates: _propTypes["default"].func.isRequired,
  t: _propTypes["default"].func.isRequired,
  viewDate: _propTypes["default"].string.isRequired,

  /**
   * A class to add to the component's [class attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/class).
   *
   * This should *not* be used to override existing styles on the component. Meridian's
   * internal CSS and HTML are private APIs and may change at any time,
   * potentially breaking custom style overrides.
   */
  className: _propTypes["default"].string,
  dateLabel: _propTypes["default"].func,
  focusDate: _propTypes["default"].string,
  hidden: _propTypes["default"].bool,
  renderDate: _propTypes["default"].func,
  // TODO: Remove in 6.x
  renderDay: _propTypes["default"].func,
  showFocusRing: _propTypes["default"].bool,
  onClickDate: _propTypes["default"].func,
  onMouseEnterDate: _propTypes["default"].func
} : {};
MiniCalendarPage.displayName = "MiniCalendarPage";
var _default = MiniCalendarPage;
exports["default"] = _default;